import { TableCell, TableRow } from '@mui/material';
import { ScoringCategory } from '../../../../types/advise';
import { TextBlock, TextSpan } from '../../../Atoms/Text';
import { ScoreBadge } from './ScoreBadge';
import { CategoryClientScore, CategoryScore, CLIENT_PURPLE } from './SupplierScoring.calc';

interface ScoringCategoryRowProps {
  category: ScoringCategory;
  score: CategoryScore;
  // Set in the "Client average" view, whose badge and caption come from the clients' scores.
  clientScore?: CategoryClientScore;
  // The Supplier Scoring tab's table has a column for each row's Details control.
  withDetails?: boolean;
}

/** A category's header row: how many of its functions are rated, or have client scores, and their average. */
export const ScoringCategoryRow = ({ category, score, clientScore, withDetails = false }: ScoringCategoryRowProps) => (
  <TableRow sx={{ backgroundColor: 'grey.50' }}>
    <TableCell
      colSpan={2}
      sx={{ borderLeft: 3, borderLeftColor: clientScore ? CLIENT_PURPLE : 'primary.main' }}>
      <TextBlock weight="semibold">{category.label}</TextBlock>
      <TextSpan
        size="xs"
        color="grey6">
        {clientScore
          ? `${clientScore.withResponses} of ${clientScore.total} functions have client responses`
          : `${score.rated} of ${score.total} rated`}
      </TextSpan>
    </TableCell>
    <TableCell align="center">
      <ScoreBadge
        score={clientScore ? clientScore.average : score.average}
        isAverage
        client={!!clientScore}
      />
    </TableCell>
    {withDetails && <TableCell />}
  </TableRow>
);
